<template>
  <div>
    <div class="header">
      <div class="row">
        <div class="small-12 columns">
          <span class="tab-message show-for-medium">Your <span v-if="showYourPartnerTab">partner's</span> career break</span>

          <ul class="tabs tabs-partner" v-if="includePartner">
            <li class="tabs-title" :class="{ 'is-active': !showYourPartnerTab }">
              <a aria-selected="true" @click.prevent="actionShowYourPartnerTab({ value: false })">You</a>
            </li>
            <li class="tabs-title" :class="{ 'is-active': showYourPartnerTab }">
              <a aria-selected="true" @click.prevent="actionShowYourPartnerTab({ value: true })">Your partner</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <section>
      <p class="section-content " v-if="!isSelfEmployed">You may want to take a break from work or perhaps reduce your working hours to travel, study or have a family. Check out the effect of reducing your working hours on your retirement benefit. </p>

      <div class="tabs-content">
        <div class="tabs-panel" :class="{ 'is-active': !showYourPartnerTab || !includePartner }">
          <career-break-inputs v-if="!isSelfEmployed"></career-break-inputs>
          <p v-else>As you have indicated you are self employed or not employed the career break function is unavailable</p>
        </div>

        <div class="tabs-panel" :class="{ 'is-active': showYourPartnerTab }" v-if="includePartner">
          <career-break-inputs :modifier="partnerModifier" v-if="!partnerIsSelfEmployed"></career-break-inputs>
          <p v-else>As you have indicated your partner is self employed or not employed the career break function is unavailable</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { Constants, EmployerType } from '@/constants';

export default {
  components: {
    CareerBreakInputs: require('../../inputs/CareerBreakInputs').default,
  },
  data() {
    return {
      partnerModifier: Constants.PARAMETER_PARTNER_SUFFIX,
    };
  },
  computed: {
    ...mapState(['inputs', 'inferred', 'ui']),
    showYourPartnerTab() {
      return this.ui.showYourPartnerTab.value;
    },
    includePartner() {
      return this.inputs.IncludePartner.value;
    },
    EmployerType() {
      return this.inferred[`EmployerType${Constants.PARAMETER_SUBJECT_SUFFIX}`].value;
    },
    isSelfEmployed() {
      return this.EmployerType === EmployerType.SELF_OR_NOT_EMPLOYED;
    },
    partnerEmployerType() {
      return this.inferred[`EmployerType${Constants.PARAMETER_PARTNER_SUFFIX}`].value;
    },
    partnerIsSelfEmployed() {
      return this.partnerEmployerType === EmployerType.SELF_OR_NOT_EMPLOYED;
    },
  },
  methods: {
    ...mapActions([
      'actionShowYourPartnerTab',
    ]),
  },
};
</script>
